import { render } from "./RegistrarEntradaForm.vue?vue&type=template&id=5b8de1d4&scoped=true"
import script from "./RegistrarEntradaForm.vue?vue&type=script&lang=js"
export * from "./RegistrarEntradaForm.vue?vue&type=script&lang=js"

import "./RegistrarEntradaForm.vue?vue&type=style&index=0&id=5b8de1d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8de1d4"]])

export default __exports__